// extracted by mini-css-extract-plugin
module.exports = {"root":"Faculties_root__oa2BV","SpecificRoot":"Faculties_SpecificRoot__jZoDg","facultySection":"Faculties_facultySection__gF9eS"};